<template>
  <div class="mop-phone pt-15">
    <v-container fluid>
      <h3 class="text-pro">New mobile phones</h3>
      <a
        href="#"
        class="text-black pt-5 pb-15"
        style="font-size: 14px; text-align: end; display: block"
        >Shop All</a
      >
      <v-col cols="12" v-if="!allData.length">
        <v-row>
          <v-col cols="3" v-for="num in 4" :key="num">
            <v-skeleton-loader type="image, article"> </v-skeleton-loader>
          </v-col>
        </v-row>
      </v-col>
      <swiper
        v-else
        :slides-per-view="4"
        :space-between="30"
        :pagination="{ clickable: true }"
        :modules="modules"
        :navigation="true"
        class="mySwiper pb-5"
        style="padding-top: 10px"
        :autoplay="{
          delay: 3000,
          pauseOnMouseEnter: true,
          disableOnInteraction: false,
        }"
        :breakpoints="breakpoints"
        :loop="true"
      >
        <swiper-slide v-for="item in allData" :key="item.id">
          <v-card elevation="0" class="pb-10 card-producte">
            <div class="master" style="position: relative">
              <img
                :src="
                  showImgData[item.title]
                    ? showImgData[item.title]
                    : item.thumbnail
                "
                style="height: 180px; width: 100%"
                alt=""
              />
              <div
                style="
                  position: absolute;
                  top: 10px;
                  right: 10px;
                  cursor: pointer;
                  width: 20px;
                  height: 20px;
                "
              >
                <v-icon
                  :style="`color:${item.wishlist ? 'red' : 'red'}`"
                  @click="item.wishlist = !item.wishlist"
                  size="20"
                >
                  {{ item.wishlist ? "mdi-heart" : "mdi-heart-outline" }}
                </v-icon>
              </div>
              <v-btn
                @click="openView(item)"
                density="compact"
                width="60"
                height="30"
                variant="outlined"
                class="bg-white quick-viewF"
              >
                Quick View
              </v-btn>
            </div>

            <v-card-text class="pa-0">
              <span style="font-weight: bold"> ({{ item.title }})</span>
              {{
                item.description.length <= 30
                  ? `${item.title} ${item.description}`
                  : `${item.title} ${item.description.substring(0, 30)}...`
              }}
            </v-card-text>
            <v-rating
              v-model="item.rating"
              half-increments
              readonly
              color="yellow-darken-2"
              size="x-small"
              density="compact"
            ></v-rating>
            <v-card-text class="pt-0">
              <del class="mr-1" style="opacity: 0.5">{{ item.price }}</del>
              <span style="font-weight: 700; margin-right: 2px">From</span>
              <span style="font-size: 16px; font-weight: 900; color: #ff0000">
                {{
                  Math.ceil(
                    item.price - item.price * (item.discountPercentage / 100)
                  )
                }}$
              </span>
            </v-card-text>
            <v-btn-toggle v-model="showImgData[item.title]" divided>
              <v-btn
                v-for="(pic, i) in item.images"
                :value="pic"
                :key="i"
                size="x-small"
              >
                <img
                  :src="pic"
                  alt=""
                  width="30"
                  height="30"
                  style="border-radius: 50%; border: 1px solid #d9d9d9"
                />
              </v-btn>
            </v-btn-toggle>
            <div class="mt-5 btn-Options">
              <v-btn
                @click="
                  $router.push({
                    name: 'product-detils',
                    params: { productId: item.id },
                    query: { name: 'phone' },
                  })
                "
                color="red"
                variant="outlined"
                style="
                  text-transform: none;
                  border-radius: 30px;
                  padding: 10px 20px;
                  font-weight: 700;
                  font-size: 13px;
                "
              >
                Choose Options
              </v-btn>
            </div>
          </v-card>
        </swiper-slide>
        <div class="swiper-pagination"></div>
      </swiper>
    </v-container>
    <v-container>
      <v-row>
        <v-col cols="6">
          <img class="w-100" src="../../images/band-left-cover.webp" alt="" />
        </v-col>
        <v-col cols="6">
          <img class="w-100" src="../../images/band-left-cover.webp" alt="" />
        </v-col>
      </v-row>
    </v-container>
  </div>
</template>

<script setup>
import { defineProps, onMounted, ref, inject, watch } from "vue";
import { Swiper, SwiperSlide } from "swiper/vue";
import { Pagination, Navigation, Autoplay } from "swiper";

const allData = ref([]);
const showImgData = ref({});
const modules = ref([Pagination, Navigation, Autoplay]);
const Emitter = inject("Emitter");
const props = defineProps({
  dataPhone: {
    type: Array,
  },
});

const openView = (productId) => {
  Emitter.emit("openView", productId);
};
const breakpoints = ref({
  0: {
    slidesPerView: 1,
  },
  580: {
    slidesPerView: 2,
  },
  767: {
    slidesPerView: 3,
  },
  990: {
    slidesPerView: 4,
  },
});

watch(
  () => allData.value,
  () => {
    localStorage.setItem("phoneData", JSON.stringify(allData.value));
    Emitter.emit("getLocalStorage");
  },
  { deep: true }
);
watch(
  () => props.dataPhone,
  () => {
    allData.value = props.dataPhone;
    if (
      localStorage.getItem("phoneData") &&
      JSON.parse(localStorage.getItem("phoneData")).length
    ) {
      allData.value = JSON.parse(localStorage.getItem("phoneData"));
    }
  },
  { deep: true }
);
onMounted(() => {
  allData.value = props.dataPhone;
  if (
    localStorage.getItem("phoneData") &&
    JSON.parse(localStorage.getItem("phoneData")).length
  ) {
    allData.value = JSON.parse(localStorage.getItem("phoneData"));
  }
});
</script>

<style>
.mySwiper {
  width: 100%;
  height: 100%;
}

.swiper-slide {
  display: flex;
  justify-content: center;
  align-items: center;
}

.mop-phone .swiper-button-next::after,
.mop-phone .swiper-button-prev::after {
  font-size: 20px;
  background-color: #2196f3;
  padding: 15px 20px;
  color: white;
  font-weight: 900;
  border-radius: 50%;
  height: 40px;
  width: 40px;
  display: flex;
  justify-content: center;
  align-items: center;
}
.mop-phone .text-pro {
  font-weight: 800;
  background: linear-gradient(65deg, #1f0dff, #67d767, #ff0000);
  -webkit-background-clip: text;
  background-clip: text;
  color: transparent;
  text-transform: uppercase;
  display: flex;
  align-items: center;
  gap: 5px;
  font-size: 30px;
  justify-content: center;
}
.master .quick-viewF {
  text-transform: none;
  position: absolute;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
  border-radius: 30px;
  font-size: 12px;
  transition: 0.2s all ease-in-out;
  opacity: 0;
}
.master:hover .quick-viewF {
  opacity: 1;
}
@media (max-width: 480px) {
  .mop-phone .master-btn .imge-swiper {
    width: 200px !important;
    height: 200px !important;
  }
  .mop-phone .btn-Options {
    text-align: center;
  }
  .mop-phone .card-producte {
    text-align: center;
  }
  .mop-phone .text-pro {
    font-size: 20px;
  }
}

@media (min-width: 481px) and (max-width: 767px) {
  .mop-phone .master-btn .imge-swiper {
    width: 200px !important;
    height: 200px !important;
  }
  .mop-phone .btn-Options {
    text-align: center;
  }
  .mop-phone .card-producte {
    text-align: center;
  }
}
</style>
